import React from 'react';
import { config } from '../config/config';

const Ticker = () => {
  const tickerItems = [
    `GOLD & SILVER SELLING`,
    `WE BUY MORTGAGED/PAWNED GOLD`,
    `FREE HOME PICKUP WITHIN 10KM`,
    `INSTANT CASH PAYMENT`,
    `SERVING GURUGRAM & DELHI`,
    `ESTABLISHED ${config.business.yearEstablished}`
  ];

  return (
    <div className="ticker">
      <div className="ticker-inner">
        {tickerItems.map((item, idx) => (
          <React.Fragment key={idx}>
            <span>{item}</span>
            <span className="dot">◆</span>
          </React.Fragment>
        ))}
        {tickerItems.map((item, idx) => (
          <React.Fragment key={`dup-${idx}`}>
            <span>{item}</span>
            <span className="dot">◆</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
